import { render, staticRenderFns } from "./ReportRow.vue?vue&type=template&id=68fd9a80&scoped=true"
import script from "./ReportRow.vue?vue&type=script&lang=js"
export * from "./ReportRow.vue?vue&type=script&lang=js"
import style0 from "./ReportRow.vue?vue&type=style&index=0&id=68fd9a80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fd9a80",
  null
  
)

export default component.exports